const SectionDivider = () => (
  <div className="px-4">
    <div className="h-px bg-border max-w-6xl mx-auto" />
  </div>
);

export default SectionDivider;
